import { PlaceholdersId, TFComponent } from '@types';

import { TermsAndConditionsPlaceholder } from './termsAndConditions';

export const termsAndConditions: TFComponent = {
	component: TermsAndConditionsPlaceholder,
	id: PlaceholdersId.termsAndConditions,
	name: 'termsAndConditions',
};
